<template>
  <notifications />
  <a href="/mail"><i class="far fa-arrow-left" /> Back</a>
  <div class="row xs-mt-10">
    <mail-form
      :content="email_content"
      :email-components="emailComponents"
      :from="from"
      :template="template"
      @submit-form="submitForm"
    />
    <mail-preview
      :content="email_content"
      :default-variables="defaultVariables"
      :dummy-variables="dummyVariables"
      :email-component="emailComponent"
      :email-component-variables="emailComponentVariables"
      :from="from"
      :template="template"
      :to="to"
      :whitelabel="whitelabel"
      @selected-component="selectedComponent"
    />
  </div>
</template>

<script>
import axios from 'axios';
import MailForm from "./MailForm.vue";
import MailPreview from "./MailPreview.vue";

export default {
  components: {
    MailForm,
    MailPreview,
  },
  props: {
    template: {
      type: Object,
      default: null,
    },
    content: {
      type: Object,
      default: null,
    },
    from: {
      type: Object,
      default: null,
    },
    to: {
      type: Object,
      default: null,
    },
    emailComponent: {
      type: Object,
      default: null,
    },
    emailComponentVariables: {
      type: Object,
      default: null,
    },
    defaultVariables: {
      type: Object,
      default: null,
    },
    dummyVariables: {
      type: Object,
      default: null,
    },
    whitelabel: {
      type: Object,
      default: null,
    }
  },
  data() {
    return {
      variables: {},
      email_content: {},
      emailComponents: [],
    }
  },
  watch: {
    content: {
      handler(new_val) {
        this.email_content = new_val;
      }
    }
  },
  created() {
    this.email_content = this.content;
    this.emailComponents = this.emailComponent;
  },
  methods: {
    async submitForm() {
      const {data} = await axios.post(`/ajax/mail/content/${this.template.id}`, this.content);
      if (data.error) {
        console.error(data.error)
      } else {
        // Placeholder until we agree on notifications
        window.location.replace("/mail");
      }
    },

    selectedComponent(active_components) {
      this.emailComponents = [];
      this.emailComponents = this.emailComponent;

      this.emailComponents.forEach(component => {
        component.active = false
      });

      if (active_components && active_components.length > 0) {
        this.emailComponents.forEach(component => {
          active_components.forEach(active_component => {
            if (component.id === active_component) {
              component.active = true;
            }
          })
        })
      }
    }
  },
}
</script>
